import React, { createContext, useContext, useState, useRef } from "react";
import { useEffect } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

import { Client } from "@stomp/stompjs";

const ContextApi = createContext();

export const ContextProvider = ({ children }) => {
  //find the token in the localstorage
  // const getToken = localStorage.getItem("JWT_TOKEN")
  //   ? JSON.stringify(localStorage.getItem("JWT_TOKEN"))
  //   : null;
  //find is the user status from the localstorage
  // const isADmin = localStorage.getItem("IS_ADMIN")
  //   ? JSON.stringify(localStorage.getItem("IS_ADMIN"))
  //   : false;

  //store the token
  //const [token, setToken] = useState(getToken);

  const [token, setToken] = useState(() => localStorage.getItem("JWT_TOKEN"));

  //store the current loggedin user
  const [currentUser, setCurrentUser] = useState(null);
  //handle sidebar opening and closing in the admin panel
  const [openSidebar, setOpenSidebar] = useState(true);
  //check the loggedin user is admin or not
  const [isAdmin, setIsAdmin] = useState(false);

  const fetchUser = async () => {

    //const user = JSON.parse(localStorage.getItem("USER"));

    //if (user?.username) {
    try {
      const { data } = await api.get(`/users/me`);
      // const roles = data.roles;
      //const role = data.role;

      // if (roles.includes("ROLE_ADMIN")) {
      if (data.role === "ADMIN") {
        //localStorage.setItem("IS_ADMIN", JSON.stringify(true));
        // localStorage.setItem("IS_ADMIN", "true");
        setIsAdmin(true);
      } else {
        // localStorage.removeItem("IS_ADMIN");
        setIsAdmin(false);
      }
      setCurrentUser(data);
    } catch (error) {
      console.error("Error fetching current user", error);
      toast.error("Error fetching current user");

      setToken(null);
      localStorage.removeItem("JWT_TOKEN");
    }
    //}
  };

  //if token exist fetch the current user
  useEffect(() => {
    if (token) {
      fetchUser();
    }
  }, [token]);

  //WS
  // WebSocket

  const [stompClient, setStompClient] = useState(null);

  useEffect(() => {
    if (!token) {
      if (stompClient) {
        stompClient.deactivate();
        setStompClient(null);
      }
      return;
    }

    const client = new Client({
      // brokerURL: "ws://localhost:8080/ws",
      brokerURL: import.meta.env.VITE_API_WS_URL + "/ws",
      connectHeaders: {
        Authorization: `Bearer ${token}`,
      },
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      reconnectDelay: 5000,
      onConnect: () => {
        console.log("WebSocket connected");
        setStompClient(client);
      },
      onDisconnect: () => {
        console.log("WebSocket disconnected");
        setStompClient(null);
      },
      onStompError: (frame) => {
        console.error("STOMP error", frame);
      },
    });

    client.activate();

    return () => {
      client.deactivate();
    };
  }, [token]);

  //END WS

  //through context provider you are sending all the datas so that we access at anywhere in your application
  return (
    <ContextApi.Provider
      value={{
        token,
        setToken,
        currentUser,
        setCurrentUser,
        openSidebar,
        setOpenSidebar,
        isAdmin,
        setIsAdmin,
        fetchUser,
        stompClient,
      }}
    >
      {children}
    </ContextApi.Provider>
  );
};

//by using this (useMyContext) custom hook we can reach our context provier and access the datas across our components
export const useMyContext = () => {
  const context = useContext(ContextApi);

  return context;
};
